import ProfileContentSubpage from "@modules/profile/components/ProfileContentSubpage.vue";

export default {
  methods: {
    handleProfileClick(userId, isDisabled) {
      if (isDisabled || userId === 0) {
        return;
      }
      this.$contentSubpage.show(ProfileContentSubpage, {
        userId: userId,
      });
    },
  },
};
